var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.sizeList[_vm.size],on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"bc-input",class:{ checked: _vm.checked }}),_c('span',{staticClass:"bc-span",class:{ select: _vm.checked }})])}
var staticRenderFns = []

export { render, staticRenderFns }